"use strict";function t(t){return t&&"object"==typeof t&&"default"in t?t:{default:t}}var e=t(require("styled-components")).default.section`
  padding: 10px;
  overflow: hidden;
  position: relative;
  height: 95px;

  @media (min-width: ${({theme:t})=>t.breakpoints.large}) {
    padding: 10px 0;
  }

  .nav {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    button {
      z-index: 10;
      height: 100%;
      width: 50px;
      position: relative;
      background: transparent;
      border: none;
      cursor: pointer;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.4s ease-in-out;

      svg {
        color: ${({theme:t})=>t.colors.primary.light};
      }

      &::after {
        content: '';
        display: block;
        height: 50%;
        width: 25px;
        background: ${({theme:t})=>t.colors.common.dark};
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        z-index: -1;
        opacity: 0.5;
        transition: all 0.2s ease-in-out;
      }

      &.left {
        padding-right: 25px;

        &::after {
          left: 0;
        }
      }

      &.right {
        padding-left: 25px;

        &::after {
          right: 0;
        }

        svg {
          transform: rotate(180deg);
        }
      }

      &:hover,
      &:active,
      &:focus {
        &::after {
          opacity: 0.75;
        }
      }

      &:disabled {
        opacity: 0;
      }
    }
  }

  .wrapper {
    overflow: visible;
    display: grid;
    grid-auto-flow: column;
    grid-column-gap: 10px;
    grid-template-columns: repeat(${({length:t})=>t}, 150px);
    box-sizing: border-box;
    transform: translateX(${({offset:t})=>`${t}px`});
    transition: all 0.4s ease-in-out;
    position: absolute;
    width: 100%;
    left: 0;
    top: 10px;

    button {
      padding: 0;
      background: transparent;
      border: none;
      cursor: pointer;
      width: 100%;

      &:last-child {
        margin-right: auto;
      }
    }
  }

  picture {
    position: relative;
    width: 100%;
    height: 91px;
    display: inline-block;
    scroll-snap-align: center;
    opacity: 0.6;
    transition: all 0.2s ease-in-out;

    &.active,
    &:hover {
      opacity: 1;
    }

    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
`;module.exports=e;
//# sourceMappingURL=styles.js.map
